/*
 * @Author: sillyy
 * @Date: 2019-02-15 10:09:32
 * @LastEditors: shero
 * @LastEditTime: 2019-03-27 16:35:51
 * @Description:
 */
class Validate {
  readonly URL_REGEXP: RegExp = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  readonly LOWERCASE_REGEXP: RegExp = /^[a-z]+$/
  readonly UPPERCASE_REGEXP: RegExp = /^[A-Z]+$/
  readonly ALPHABETS_REGEXP: RegExp = /^[A-Za-z]+$/
  readonly NUMBER_REGEXP: RegExp = /^\d+$/
  readonly EMAIL_REGEXP: RegExp = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
  readonly PHONE_REGEXP_1: RegExp = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/
  readonly PHONE_REGEXP_2: RegExp = /^1[3456789]\d{9}$/
  readonly POSITIVE_INTEGER_REGEXP = /^[0-9]+$/

  /**
   * 合法url
   */
  validateURL(textval: string) {
    return this.URL_REGEXP.test(textval)
  }
  /**
   * 小写字母
   */
  validateLowerCase(str: string) {
    return this.LOWERCASE_REGEXP.test(str)
  }
  /**
   * 大写字母
   */

  validateUpperCase(str: string) {
    return this.UPPERCASE_REGEXP.test(str)
  }
  /**
   * 大小写字母
   */

  validateAlphabets(str: string) {
    return this.ALPHABETS_REGEXP.test(str)
  }
  /**
   * 数字
   */
  validateNumber(value: string, callback?: any) {
    if (value === '') {
      callback()
    } else if (!this.NUMBER_REGEXP.test(value)) {
      callback(new Error('请输入数字'))
    } else {
      callback()
    }
  }
  /**
   * 邮箱
   */
  validateEmail(value: string, callback?: any) {
    if (value === '') {
      callback('邮箱为空')
      return false
    } else if (!this.EMAIL_REGEXP.test(value)) {
      callback('邮箱格式不正确')
      return false
    } else {
      return true
    }
  }
  /**
   * 手机
   */
  validatePhone(value: string, callback?: any) {
    if (value === '') {
      callback('手机号码为空')
      return false
    } else if (
      !this.PHONE_REGEXP_1.test(value) ||
      !this.PHONE_REGEXP_2.test(value)
    ) {
      callback('手机号码格式不正确')
      return false
    } else {
      return true
    }
  }
  /**
   * 验证手机号-用于element 表单验证规则
   */
  validatorPhone_rule(rule: any, value: any, callback: Function) {
    if (
      !/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(value) ||
      !/^1[3456789]\d{9}$/.test(value)
    ) {
      callback(new Error('手机号格式不正确'))
    } else {
      callback()
    }
  }
  /**
   * 验证邮箱-用于element 表单验证规则
   */
  validatorEmail_rule(rule: any, value: any, callback: Function) {
    if (
      !/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
        value
      )
    ) {
      callback(new Error('邮箱不正确'))
    } else {
      callback()
    }
  }
  /**
   * 验证数字-用于element 表单验证规则
   */
  validatorNumber_rule(rule: any, value: any, callback: Function) {
    if (!/^[0-9]+$/.test(value)) {
      callback(new Error('只能为正整数'))
    } else {
      callback()
    }
  }

  validatorTimeDes_rule(rule: any, value: any, callback: Function) {
    if (value === '') {
      callback(new Error('时间描述不能为空'))
    } else {
      callback()
    }
  }

  validatorPrice_rule(rule: any, value: any, callback: Function) {
    if (!/^[0-9]+$/.test(value)) {
      callback(new Error('价格只能为正整数'))
    } else {
      callback()
    }
  }

  validatorDateS_rule(rule: any, value: any, callback: Function) {
    let d = new Date(value)
    console.log(d)
    if (d.toString() === 'Invalid Date') {
      callback(new Error('非法时间格式'))
    } else {
      callback()
    }
  }
}
export default new Validate()
